import { NgModule } from '@angular/core';


import { FuseNavigationModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { NavbarVerticalStyle1Component } from './style-1.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        NavbarVerticalStyle1Component
    ],
    imports     : [
        SharedModule,
        FuseSharedModule,
        FuseNavigationModule
    ],
    exports     : [
        NavbarVerticalStyle1Component
    ]
})
export class NavbarVerticalStyle1Module
{
}
